import { ListItemMenu } from "@components/common/mobile/list-item-menu";
import { MemberTableSubject } from "@components/common/faro-table/faro-table-types";
import { SdbMemberTypes } from "@custom-types/member-types";
import { SdbProject } from "@custom-types/project-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { useMembersMenuOptions } from "@pages/members/use-members-menu-options";

interface Props {
  /** The member to show options for */
  member: SdbMemberTypes;

  /** Context in which the members table is used */
  subjectType: MemberTableSubject;

  /** The selected project (for project member tables) */
  selectedProject?: SdbProject | null;

  /** The selected group (for group member tables) */
  group?: FaroCoreApiTypes.GroupDetailResponse | null;

  /** The selected team (for team member tables) */
  team?: FaroCoreApiTypes.Team;
}

/**
 * Renders a 3-dot menu with actions for a single member row in the table.
 */
export function MemberOptionsMenu({
  member,
  subjectType,
  selectedProject,
  group,
  team,
}: Props): JSX.Element {
  const menuItems = useMembersMenuOptions({
    subjectType,
    selectedProject,
    group,
    team,
  });

  return <ListItemMenu<SdbMemberTypes> item={member} menuItems={menuItems} />;
}
